import React from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import type { MediaProps } from './Media';
import Media from './Media';
import * as styles from '../css/side-iframe-video.css';

type IframeProps = ComponentPropsWithoutRef<'iframe'>;

const SideIframeVideo = (props: Omit<MediaProps<IframeProps>, 'component'>) => (
    <Media
        component="iframe"
        className={styles.root}
        allowFullScreen
        {...props}
    />
);

export default SideIframeVideo;
